import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import { Popover as FoundationsPopover } from 'foundations-components/transitional/components/Popover';
import { useIsPillBorderRadius } from 'portals-platform-lib';
import { jsx as _jsx } from "react/jsx-runtime";
export const Popover = _ref => {
  let props = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  const isUsingPillBorderRadius = useIsPillBorderRadius();
  return /*#__PURE__*/_jsx(FoundationsPopover, Object.assign({}, props, {
    borderRadius: isUsingPillBorderRadius ? '0' : '400'
  }));
};